<template>
  <div class="popup-backdrop" v-if="open">
    <div class="popup-card">
      <div class="popup-message">
        <div class="popup-title">{{ title }}</div>
        <div class="popup-subtitle">{{ subtitle }}</div>
      </div>
      <div class="popup-btn-row">
        <button class="popup-btn" @click="handleYes">{{ $t('yesNoPopup.yes_proceed') || 'Yes, Proceed' }}</button>
        <button class="popup-btn popup-btn-secondary" @click="handleNo">{{ $t('yesNoPopup.no_keep_editing') || 'No, Keep Editing' }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  open: Boolean,
  title: String,
  subtitle: String,
  onYes: Function,
  onNo: Function,
})
function handleYes() {
  props.onYes && props.onYes()
}
function handleNo() {
  props.onNo && props.onNo()
}
</script>

<style scoped>
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(30, 30, 40, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
}
.popup-card {
  background: var(--secondary-color);
  border-radius: 13px;
  box-shadow: 0 2px 18px #aaa2;
  padding: 32px 28px 22px 28px;
  min-width: 300px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}
.popup-message {
  font-size: 1.1rem;
  color: #222d3d;
  text-align: center;
}
.popup-title {
  font-weight: 700;
  margin-bottom: 4px;
}
.popup-subtitle {
  font-weight: 500;
  color: #222d3d;
}
.popup-btn-row {
  display: flex;
  gap: 18px;
  justify-content: center;
  width: 100%;
}
.popup-btn {
  padding: 8px 26px;
  border: none;
  border-radius: 7px;
  font-size: 1.02rem;
  cursor: pointer;
  background: var(--primary-color);
  color: var(--secondary-color);
  transition: background 0.16s;
  font-weight: 500;
}
.popup-btn:hover {
  background: var(--primary-color);
}
.popup-btn-secondary {
  background: var(--secondary-color);
  color: var(--primary-color);
}
.popup-btn-secondary:hover {
  background: var(--secondary-color);
}
</style>
